// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Transform from '../math/Transform';

/**
 * Representation of a Joint in a Skeleton. Meant to be used within a specific Skeleton object.
 */
class Joint {

  /**
   * @param {string} name Name of joint
   */
  constructor(name) {
    this._name = name;
  
    this._index = 0;
    this._parentIndex = Joint.NO_PARENT;
    this._inverseBindPose = new Transform();
  }
  
}

Joint.NO_PARENT = -32768;

export default Joint;
